export default "__VITE_ASSET__B$XMe1tq__"